<script>
  import { sgettext } from '../../../../i18n.js';
  import { submit } from '../../../../utils.js';
  import MegaSelect from '../../../MegaSelect/MegaSelect.svelte';

  export let activityVersionId;
  export let item = null;
  export let options;
  export let isPPE = false;
  export let editable = true;
  export let retrieveItems;
  export let retrieveOptions;
  export let actionUrl;
  let isWaiting = false;
  let error;

  // Creating
  export let isCreating = false;
  let createValues = {global_control_id: null};
  let cancelCreatingMode = () => {
    error = undefined;
    isWaiting = false;
    isCreating = false;
  };
  $: isValidCreateForm = createValues.global_control_id ? true: false;
  async function addItem() {
    if (!isValidCreateForm) return;

    let payload = {
      global_control_id: createValues.global_control_id,
    };

    error = undefined;
    isWaiting = true;
    const response = await submit(actionUrl, 'POST', payload);

    if (response.ok) {
      await retrieveItems();
      cancelCreatingMode();
    } else {
      isWaiting = false;
      const json = await response.json();
      error = json.non_field_errors[0];
    }
  }

  // Editing
  let isEditing = false;
  let toEditItem = null;
  let editValues = {global_control_id: null};
  async function setEditingMode (item) {
    error = undefined;
    if (editable) {
      await retrieveOptions();
      isEditing = true;
      toEditItem = {...item};
      editValues = {global_control_id: null};
    }
  }
  let cancelEditingMode = () => {
    error = undefined;
    isWaiting = false;
    isEditing = false;
    toEditItem = null;
    editValues = {global_control_id: null};
  };
  $: isValidEditForm = editValues.global_control_id ? true : false;
  async function updateItem(item) {
    if (!isValidEditForm) return;

    let payload = {
      global_control_id: editValues.global_control_id,
    };

    error = undefined;
    isWaiting = true;
    const url = `${actionUrl}${item.id}/`;
    const response = await submit(url, 'PUT', payload);

    if (response.ok) {
      await retrieveItems();
      cancelEditingMode();
    } else {
      isWaiting = false;
      const json = await response.json();
      error = json.non_field_errors[0];
    }
  }

  // Deleting
  export let isDeleting = false;
  export let toDeleteItem = null;
  let tryToDelete = (item=null) => {
    if (item) {
      isDeleting = true;
      toDeleteItem = {...item};
    }
  };

  // MegaSelect handlers
  let handleSelectControl = event => {
    error = undefined;
    if (isCreating) {
      createValues.global_control_id = event.detail.id;
    } else if (isEditing) {
      editValues.global_control_id = event.detail.id;
    }
  }
  let handleClearControl = () => {
    error = undefined;
    if (isCreating) {
      createValues.global_control_id = null;
    } else if (isEditing) {
      editValues.global_control_id = null;
    }
  }
</script>

<tr class:dangerBorder={item && !item.valid}>

  {#if isCreating}
    <td>
      <MegaSelect
        id={`new-activity-version-${isPPE?'ppe':'control'}`}
        {options}
        placeholder={sgettext('$$SEARCHSELECT_CONTROL_$$')}
        noOptionsMessage={sgettext('$$RESULTS_FOUND$$')}
        itemValueKey='id'
        itemLabelKey='name'
        itemDescriptionKey='description'
        showDescriptions={true}
        getItemImageUrl={i => i.icon ? i.icon.url : ''}
        onSelectItem={handleSelectControl}
        onClear={handleClearControl}
        readOnly={isWaiting}
        isWaiting={isWaiting}
      />
      {#if error}
        <small class='text-danger'>{error}</small>
      {/if}
    </td>
    <td class='actions'>
      <button
        class='btn btn-sm btn-primary mr-2'
        on:click={addItem}
        disabled={!isValidCreateForm || isWaiting}
      >
        {#if isWaiting}
          {sgettext('$$ADDING_$$')}
        {:else}
          {sgettext('$$ADD_1$$')}
        {/if}
      </button>
      {#if isWaiting}
        <div class='d-inline-block mx-2'>
          <div class='spinner-border spinner-border-sm text-primary' role='status'>
            <span class='sr-only'>{sgettext('$$LOADING$$')}...</span>
          </div>
        </div>
      {:else}
        <button
          class='btn btn-sm btn-outline'
          on:click={cancelCreatingMode}
        >
          {sgettext('$$CANCEL$$')}
        </button>
      {/if}
    </td>

  {:else if isEditing && item?.id && toEditItem?.id && item.id === toEditItem.id}
    <td>
      <MegaSelect
        id={`control-${item.id}`}
        {options}
        placeholder={sgettext('$$SEARCHSELECT_CONTROL_$$')}
        noOptionsMessage={sgettext('$$RESULTS_FOUND$$')}
        itemValueKey='id'
        itemLabelKey='name'
        itemDescriptionKey='description'
        showDescriptions={true}
        getItemImageUrl={i => i.icon ? i.icon.url : ''}
        selectedItem={toEditItem.global_control}
        onSelectItem={handleSelectControl}
        onClear={handleClearControl}
        readOnly={isWaiting}
        isWaiting={isWaiting}
      />
      {#if error}
        <small class='text-danger'>{error}</small>
      {/if}
    </td>
    <td class='actions'>
      <button
        class='btn btn-sm btn-primary mr-2'
        on:click={() => updateItem(item)}
        disabled={!isValidEditForm || isWaiting}
      >
      {#if isWaiting}
        {sgettext('$$UPDATING_$$')}
      {:else}
        {sgettext('$$UPDATE_1$$')}
      {/if}
    </button>
    {#if isWaiting}
      <div class='d-inline-block mx-2'>
        <div class='spinner-border spinner-border-sm text-primary' role='status'>
          <span class='sr-only'>{sgettext('$$LOADING$$')}...</span>
        </div>
      </div>
    {:else}
      <button
        class='btn btn-sm btn-outline'
        on:click={cancelEditingMode}
      >
        {sgettext('$$CANCEL$$')}
      </button>
    {/if}
    </td>

  {:else if item?.id}
    <td>
      <div class="field-container" title="{item.global_control.name}: {item.global_control.description}">
        <div class="wrapper">
          {#if !item.valid}
            <i class="fa fa-exclamation-circle text-danger mr-2 mt-1" title="{isPPE? sgettext('$$PPE_NOT_ENABLED_BRANCH$$') : sgettext('$$CONTROL_NOT_ENABLED_BRANCH$$')}"></i>
          {/if}
          <img
            src="{item.global_control.icon.url}"
            alt="{item.global_control.name}"
          />
          <div class="label-container">
            <div class="text">{item.global_control.name}</div>
            <div class="subtext">{item.global_control.description}</div>
          </div>
        </div>
      </div>
    </td>
    {#if editable}
      <td class='actions'>
        {#if !isEditing}
          <span on:click={() => setEditingMode(item)}>
            <i class='fas fa5-edit'/>
          </span>
          <span on:click={() => tryToDelete(item)}>
            <i class='fas fa5-trash-alt'/>
          </span>
        {/if}
      </td>
    {/if}
  {/if}

</tr>
  
<style>
  .dangerBorder {
    border: solid 3px #dc3545 !important;
  }
  
  td {
    width: 50%;
  }

  .actions {
    text-align: right;
    min-width: 130px;
    white-space: nowrap;
  }

  .actions i {
    margin: 0 0 0 20px;
    cursor: pointer;
  }

  .field-container {
      box-sizing: border-box;
      height: 72px;
      position: relative;
      display: grid;
      align-items: center;
      padding: 0;
      margin: 0;
  }

  .wrapper {
      overflow: hidden;
      display: flex;
      flex-direction: row;
  }

  .field-container .text {
      font-weight: bold;
      font-size: medium;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }

  .field-container .subtext {
      font-weight: normal;
      font-size: small;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }

  .field-container img {
      flex: 0 0 50px;
      margin: 0 10px 5px 0;
      padding-bottom: 10px;
      width: 50px;
      max-height: 80px;
      overflow: hidden;
  }
</style>
  